export default __webpack_public_path__ + "static/media/p2.a54f2619.JPG";